import {goTo} from '@/utils';
import {goToUrl} from '@/common-pages/game-navigate';
import globalStore from '@/services/global.state';
import {PromotionEntryItem} from './type';

interface ExecutePromotionActionOptions {
  login: boolean;
  onDownloadApp: (modalImageUrl?: string) => void;
}

export function executePromotionAction(
  item: PromotionEntryItem,
  {login, onDownloadApp}: ExecutePromotionActionOptions,
) {
  const {action} = item;

  switch (action.type) {
    case 'OPEN_URI':
      if (action.loginRequired && !login) {
        goTo('Login');
        return;
      }
      goToUrl(action.uri, item.title);
      return;
    case 'OPEN_RICH_TEXT':
      globalStore.asyncSetItem(
        'promotion-detail',
        JSON.stringify({
          activityTitle: item.title,
          activityContent: action.content,
          activityIcon: item.imageUrl,
          activityUrl: '',
        }),
      );
      goTo('PromotionDetail');
      return;
    case 'DOWNLOAD_APP':
      onDownloadApp(action.modalImageUrl);
      return;
    case 'NONE':
      return;
  }
}
